import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MyShoppingService } from '../../../../../shared/services/apis/platform/my-shopping.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { RatingPostRequest } from '../../../../../shared/services/requests/platform/rating-post.request';

@Component({
  selector: 'app-modal-rating',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogActions, MatDialogContent],
  templateUrl: './modal-rating.component.html',
  styleUrls: ['./modal-rating.component.css']
})
export class ModalRatingComponent implements OnInit {

  rating: number = 0;
  hovered: number = 0;
  stars = [1, 2, 3, 4, 5];

  constructor(
    public dialogRef: MatDialogRef<ModalRatingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idBook: number, idKitPaymentItem: number },
    private myShoppingService: MyShoppingService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  rate(star: number): void {
    this.rating = star;

    const request: RatingPostRequest = {
      idBook: this.data.idBook,
      idKitPaymentItem: this.data.idKitPaymentItem,
      star: this.rating
    };

    this.myShoppingService.post(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', 'Avaliação enviada com sucesso!', AlertType.success);
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.alertService.show('Erro', 'Não foi possível enviar sua avaliação.', AlertType.error);
        console.error(error);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}